module.exports = __webpack_public_path__ + "static/firdaus-full-d64d02815434add1b31ba551d564a473.jpg";